import { useRef, useLayoutEffect, useEffect } from 'react';

// Improved version of https://usehooks.com/useOnClickOutside/

export default function useOnClickOutside(ref: any, cb: Function) {
	const refCb = useRef(cb);

	useLayoutEffect(() => {
		refCb.current = cb;
	});

	useEffect(() => {
		const handler = (e: any) => {
			const element = ref.current;
			if (element && !element.contains(e.target)) {
				refCb.current(e);
			}
		};

		document.addEventListener('mousedown', handler);
		document.addEventListener('touchstart', handler);

		return () => {
			document.removeEventListener('mousedown', handler);
			document.removeEventListener('touchstart', handler);
		};
	}, [ref]);
}
